import React from 'react';
import TreatmentsTemplate from '../treatmentsTemplate/TreatmentsTemplate';

const pageTitle = 'Nsaids';
const pageSubTitle = 'What are Nsaids?';
const pageDescription = 'Over-the counter pain relievers and anti-inflammatory medication are usually the first line of therapy for osteoarthritis of the knee. Examples of anti-inflammatory medications include ibuprofen, naproxen and tylenol.';
const videoKey = '0mTyQNToy3s';

const resourceLinks = [
    {
        title: 'Osteoarthritis',
        link: 'https://healthy.kaiserpermanente.org/health-wellness/health-encyclopedia/he.osteoarthritis.hw125723',
    },
    {
        title: 'Knee Osteoarthritis',
        link: 'https://mydoctor.kaiserpermanente.org/mas/structured-content/Condition_Knee_Osteoarthritis.xml?co=%2Fregions%2Fmas',
    },
    {
        title: 'Osteoarthritis',
        link: 'https://mydoctor.kaiserpermanente.org/mas/structured-content/Condition_Osteoarthritis.xml?co=%2Fregions%2Fmas',
    },
];

const Nsaids = () => {
    return (
        <TreatmentsTemplate
            pageTitle={pageTitle}
            pageSubTitle={pageSubTitle}
            pageDescription={pageDescription}
            videoKey={videoKey}
            resourceLinks={resourceLinks}
            pageType="treatment"
        />
    );
};

export default Nsaids;